// Segmented List ⇄ Summary toggle shared by the unified and per-portal queues.
import React from 'react';
import { ListBullets, ChartBar } from '@phosphor-icons/react';

const TABS = [
  { key: 'list', label: 'List', icon: ListBullets },
  { key: 'summary', label: 'Summary', icon: ChartBar },
];

export default function QueueViewToggle({ view, onChange }) {
  return (
    <div className="inline-flex items-center rounded-md bg-zinc-100 p-0.5 ring-1 ring-zinc-200" data-testid="queue-view-toggle">
      {TABS.map(({ key, label, icon: Icon }) => (
        <button
          key={key}
          onClick={() => onChange(key)}
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-xs font-medium transition-colors ${
            view === key ? 'bg-white text-zinc-900 shadow-sm' : 'text-zinc-500 hover:text-zinc-800'
          }`}
          data-testid={`queue-view-${key}`}
        >
          <Icon size={14} weight={view === key ? 'fill' : 'regular'} /> {label}
        </button>
      ))}
    </div>
  );
}
